<script lang="ts" setup>
import { copyToClipboard } from "@/utils";
import $events from "@/event-bus";
import { DocumentDuplicateIcon } from "@heroicons/vue/24/outline";
import { analytics } from "@/services/segment.ts";

const props = defineProps<{
    segmentEventName?: string;
}>();

const handleCopy = async () => {
    try {
        const copyTextElement = document.getElementById("copy-text");
        if (copyTextElement) {
            const textToCopy =
                copyTextElement.textContent || copyTextElement.innerText || "";
            await copyToClipboard(textToCopy);
            $events.$emit("toastNotification", {
                status: "success",
                heading: "Copied to clipboard!",
            });
            if (props.segmentEventName) {
                analytics.track(props.segmentEventName);
            }
        } else {
            console.error('Element with id "copy-text" not found');
        }
    } catch (error) {
        console.error("Failed to copy text:", error);
        $events.$emit("toastNotification", {
            status: "error",
            heading: "Failed to copy text",
        });
    }
};
</script>

<template>
    <div
        class="mb-4 bg-gray-50 border border-gray-300 rounded-md p-4 flex gap-2 items-center justify-between"
    >
        <div class="flex gap-2 items-center">
            <p id="copy-text" class="font-medium text-black text-sm">
                <slot>Text</slot>
            </p>
        </div>
        <button
            @click="handleCopy"
            class="flex items-center gap-2 bg-gray-600 text-white rounded-md px-3 py-2 text-sm font-semibold hover:bg-gray-700 transition-colors"
        >
            <DocumentDuplicateIcon class="h-5 w-5" />
            Copy
        </button>
    </div>
</template>
